<template>
  <div>
    <div class="iotplt-card-box">
      <search-esim-goods @submit="submitSearch" />
    </div>

    <div style="padding-top: 15px">
      <a-empty v-if="!loading && data.length === 0" />
      <a-row :gutter="24" v-else>
        <a-col :span="8">
          <product-card :data="data" :loading="loading" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { findEsimGoods } from '@/api/esim_goods'
import SearchEsimGoods from '@/views/agent_purchase_items/esim_goods/Search'
import ProductCard from '@/views/agent_purchase_items/esim_goods/ProductCard'

export default {
  name: 'EsimGoodsList',
  components: {
    SearchEsimGoods,
    ProductCard
  },
  data() {
    return {
      loading: true,
      data: [],
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findEsimGoods(
        Object.assign({ agent_id: this.$store.getters.userAgentId }, this.query)
      ).then((res) => {
        if (res.code === 0) {
          this.data = res.data || []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
